<template>
  <div id="hres82e-detail" class="hres82e-detail hrms-searchbox-table clearfix">
    <div :class="[searchboxDisp == true ? 'search-group-wrapper' : 'search-group-wrapper-min']">
      <div ref="searchboxPanel" class="search-box-panel clearfix" v-show="searchboxDisp">

        <div class="room-title">
          <!-- <div class="roomno">{{ indexSelected.roomno }}</div> -->
          <div class="desc_roomno">{{ indexSelected.desc_roomno }}</div>
        </div>
        <img src="../../assets/img/meetingroom.jpg" style="width: 100%">

        <calendar :calendar="calendar"
                  :setDateSelected="setDateSelected"
                  :days="label.days[app.nowLang]"
                  :month="label.month[app.nowLang]"
                  :defaultDate="defaultDate"
                  @setLoadingParentBool="loadingParentBool = arguments[0]"
                  :toggle="toggle" />
      </div>
    </div>

    <div ref="table" class="clearfix" :class="[searchboxDisp == true ? 'table-box-wrapper' : 'table-box-wrapper-full']">
      <div v-show="calendarDetailDisp">
        <div class="box-header with-border">
          <h3 class="box-title">
            <i class="fa fa-file-text margin-r-5"></i>
            {{ labels['HRES82EC2']['110'] }} {{ labels['HRES82EC2']['180'] }} {{ setDateOutput(dateSelected) }}
          </h3>
        </div>
        <hrms-table :columns="detailColumns"
                    :data="calendarDetail"
                    :nowLang="nowLang"
                    :addEvent="addEvent"
                    :addBtnDisp="presentConFlg"
                    :editEvent="editEvent"
                    :cancelEvent="cancelEvent"
                    :rowDisableCondition="rowDisableCondition" />
        <div class="col-xs-12">
          <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
        </div>
      </div>

      <reserve v-show="reserveDisp"
              :labels="labels"
              :toggle="toggle"
              :nowLang="nowLang"
              :labelsButton="labelsButton"
              :descCodapp="descCodapp"
              :dateSelected="dateSelected"
              :indexSelected="indexSelected"
              :calendarSelected="calendarSelected"
              :searchIndex="searchIndex"
              :detail="reserveDetail"
              :currentUser="codempid"
              :reserveYear="reserveYear"
              :reserveMonth="reserveMonth"
              :postHres82eReserveSave="postHres82eReserveSave"
              :presentConFlg="presentConFlg" />
    </div>
  </div>
</template>

<script>
import calendar from 'components/hres82e/calendar'
import reserve from 'components/hres82e/reserve'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres82e-detail',
  props: [ 'calendarDetailDisp', 'reserveDisp', 'labels', 'labelsButton', 'toggle', 'nowLang', 'detailColumns', 'indexSelected', 'calendarSelected', 'dateSelected', 'setDateSelected', 'reserveDay', 'reserveDate', 'reserveMonth', 'reserveYear', 'searchIndex', 'calendar', 'calendarDetail', 'receivedHres82eCalendar', 'receivedHres82eReserveCreate', 'receivedHres82eReserveDetail', 'setCalendarSelected', 'postHres82eReserveCancel', 'descCodapp', 'reserveDetail', 'postHres82eReserveSave' ],
  data () {
    return {
      app: this.$parent.$parent.$parent.$parent,
      label: require('src/../config/label'),
      loadingParentBool: true,
      searchboxDisp: true,
      defaultDate: {
        currentYear: this.reserveYear,
        currentMonth: this.reserveMonth,
        currentDate: this.reserveDate,
        currentDay: this.reserveDay
      },
      presentConFlg: true
    }
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    }
  },
  watch: {
    reserveYear () {
      this.setDefaultDate()
    },
    reserveMonth () {
      this.setDefaultDate()
    },
    reserveDate () {
      this.setDefaultDate()
    },
    dateSelected () {
      let arrDateSelected = this.dateSelected.split('/')
      let d1 = new Date()
      let d2 = new Date(arrDateSelected[1] + '/' + arrDateSelected[0] + '/' + arrDateSelected[2])
      d1.setHours(0, 0, 0, 0)

      if (d1 > d2) {
        this.presentConFlg = false
      } else {
        this.presentConFlg = true
      }
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    setDefaultDate () {
      this.defaultDate = {
        currentYear: this.reserveYear,
        currentMonth: this.reserveMonth,
        currentDate: this.reserveDate,
        currentDay: this.reserveDay
      }
    },
    pageDetail (event, param) {
      switch (event) {
        case 'add':
          let searchParams = {
            roomno: this.indexSelected.roomno,
            dtereserv: this.dateSelected
          }
          this.receivedHres82eReserveCreate(searchParams)
          this.toggle('reserve')
          break
        case 'edit':
          if (param.seqno) {
            if (this.indexSelected.staappr === 'C') {
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            let searchParams = {
              roomno: this.indexSelected.roomno,
              dtereserv: this.dateSelected,
              seqno: param.seqno
            }
            this.receivedHres82eReserveDetail(searchParams)
            this.toggle('reserve')
          }
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add')
    },
    editEvent (param) {
      if (!this.presentConFlg) {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1501'),
          confirmButtonText: constLabels('ok')
        })
      }
      this.setCalendarSelected(param)
      this.pageDetail('edit', param)
    },
    cancelEvent (param) {
      if (!this.presentConFlg) {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1501'),
          confirmButtonText: constLabels('ok')
        })
      } else {
        this.setCalendarSelected(param)
        if (this.calendarSelected.seqno) {
          let sendParams = {
            roomno: this.indexSelected.roomno,
            dtereserv: this.dateSelected,
            seqno: param.seqno,
            dtemonth: this.reserveMonth,
            dteyear: this.reserveYear
          }
          this.postHres82eReserveCancel({ cancelParams: sendParams, searchParams: this.searchIndex })
        }
      }
    },
    rowDisableCondition (dataRow) {
      return false
    }
  },
  components: {
    calendar,
    reserve
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?602640a4